import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import App from "./App.tsx";
import "./index.css";

// Sentry ładowany dopiero po pierwszym renderze, żeby nie blokować startu strony.
const startSentry = () => {
  import("@sentry/react")
    .then((Sentry) => {
      Sentry.init({
        dsn: "https://21af33d49db8cf3c26480fe0887429ed@o4511535070642176.ingest.de.sentry.io/4511535085584464",
        integrations: [Sentry.browserTracingIntegration()],
        tracesSampleRate: 1.0,
      });
    })
    .catch(() => {
      /* brak monitoringu nie może psuć aplikacji */
    });
};

const idle = (window as unknown as {
  requestIdleCallback?: (cb: () => void, opts?: { timeout: number }) => void;
}).requestIdleCallback;

if (idle) {
  idle(startSentry, { timeout: 5000 });
} else {
  setTimeout(startSentry, 2000);
}


createRoot(document.getElementById("root")!).render(
  <HelmetProvider>
    <App />
  </HelmetProvider>
);
